import { configureStore } from "@reduxjs/toolkit";
import roleSliceReducer from "../slices/role-slice";
import manageLocationsSliceReducer from "../slices/location-slice";
import industrySliceReducer from "../slices/industry-slice";
import domainSkillSliceReducer from "../slices/domain-skill-slice";
import softSkillSliceReducer from "../slices/soft-skill-slice";
import signinSliceReducer from "../slices/signin-slice";
import createNewJobSliceReducer from "../slices/create-new-job-slice";
import createCandidateSliceReducer from "../slices/create-candidate-slice";
import createUserManagementSliceReducer from "../slices/create-new-user-management-slice";
import createNewQuestionSliceReducer from "../slices/create-new-question-slice";
import defineInterviewSliceReducer from "../slices/define-interview-slice";
import signUpReducer from "../slices/sign-up-slice";
import inviteCandidatesSliceReducer from "../slices/invite-candidates-slice";
import fromPreviousPositionSliceReducer from "../slices/from-previous-job-slice";
import invitedCandidatesSliceReducer from "../slices/invited-candidates-slice";
import userInfoReducer from "../slices/user-information-slice";
import entitySliceReducer from "../slices/entity-slice";
import interviewResponseSlice from "../slices/interview-responses-slice";
import interviewSlice from "../slices/interview-slice";
import interviewResponsesL1DashboardSliceReducer from "../slices/interview-responses-l1-dashboard-slice";
import interviewResponsesRecruiterDashboardSliceReducer from "../slices/interview-responses-recruiter-dashboard-slice";
import summaryScoresSliceReducer from "../slices/summary-scores-slice";
import rootSliceReducer from "../slices/root-slice";
import candidateIntegrityScoreSliceReducer from "../slices/candidate-integrity-score-slice";
import dynamicFollowupQuestionSliceReducer from "../slices/dynamic-followup-question-slice";
import candidateCompetencyScoreSliceReducer from "../slices/candidate-competency-score-slice";
import candidateComparisonSliceReducer from "../slices/candidate-comparison-slice";
import personalityAssessmentSliceReducer from "../slices/personality-assessment-slice";
import referenceCheckSliceReducer from "../slices/reference-check-slice";
import candidatePortalSliceReducer from "../slices/candidate-portal-slice";
import emailSystemSliceReducer from "../slices/email-system-slice";
import jobScopeSliceReducer from "../slices/job-scope-slice";
import jobsCacheSliceReducer from "../slices/jobsCacheSlice";
import entityBrandingSliceReducer from "../slices/entityBrandingSlice";
import questionBankSliceReducer from "../slices/question-bank-slice";
import questionTemplateSliceReducer from "../slices/question-template-slice";
import attributionSliceReducer from "../slices/attribution-slice";
import percentileSliceReducer from "../slices/percentile-slice";

import { apiSlice } from "./api";

const store = configureStore({
  reducer: {
    roleSliceReducer,
    industrySliceReducer,
    domainSkillSliceReducer,
    manageLocationsSliceReducer,
    softSkillSliceReducer,
    signinSliceReducer,
    createNewJobSliceReducer,
    createCandidateSliceReducer,
    createNewQuestionSliceReducer,
    defineInterviewSliceReducer,
    signUpReducer,
    inviteCandidatesSliceReducer,
    interviewResponsesL1DashboardSliceReducer,
    interviewResponsesRecruiterDashboardSliceReducer,
    fromPreviousPositionSliceReducer,
    invitedCandidatesSliceReducer,
    userInfoReducer,
    entitySliceReducer,
    interviewResponseSlice,
    interviewSlice,
    summaryScoresSliceReducer,
    rootSliceReducer,
    createUserManagementSliceReducer,
    candidateIntegrityScoreSliceReducer,
    dynamicFollowupQuestionSliceReducer,
    candidateCompetencyScoreSliceReducer,
    candidateComparisonSliceReducer,
    personalityAssessmentSliceReducer,
    referenceCheckSliceReducer,
    candidatePortalSliceReducer,
    emailSystemSliceReducer,
    jobScopeSliceReducer,
    jobsCacheSliceReducer,
    entityBrandingSliceReducer,
    questionBankSliceReducer,
    questionTemplateSliceReducer,
    attributionSliceReducer,
    percentileSliceReducer,
    [apiSlice.reducerPath]: apiSlice.reducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(apiSlice.middleware)
});

export default store;